module.exports = "/packs/media/images/icon_conversation-d7a50497914a6356f979fd270673765c.png";